export default {
  slug: 'taco-recombinator',
  company: "Particle Design",
  logo: null,
  blurb: {
    headline: "Sometimes you just want tacos.",
    tags: [],
    background: require('./preview.jpg'),
  },
  content: [
    "# title\ncase study here - ideally would be able to write a super long module-esque nesting thing",
  ],
};



// WEBPACK FOOTER //
// ./src/content/work/taco-recombinator/index.js